import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

export type MenuItemProps = SliceComponentProps<Content.MenuItemSlice>;

const MenuItem = ({ slice }: MenuItemProps) => (
  <section
    data-slice-type={slice.slice_type}
    data-slice-variation={slice.variation}
  >
    Placeholder component for menu_item (variation: {slice.variation}) Slices
  </section>
);

export default MenuItem;
